<template>
  <main-layout>

    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-07-05"></menubar>
    </div>
    <!--  左メニュー 終了 -->

    <div slot="header">
      <head-title>
        <img
          @click="back"
          slot="back"
          class="back-image"
          src="@/assets/icon/sp-icon-arrow-back.svg"
          alt="">
        <!-- 投稿内容確認 -->
        <label class="m-left-5" slot="title">
          <span>{{$t("title.system.faq.confirm")}}</span>
        </label>
        <narrow-down
          @click="save"
          slot="create"
          class="create-btn">
          {{$t("button.common.data.create")}}
        </narrow-down>
      </head-title>
    </div>

    <div slot="body">

      <div class="confirm-panel">

        <!-- 登録種別 -->
        <div class="form-group-start">
          <div class="label-width">
            <span>{{$t("label.help.question.createType")}}</span>
          </div>
          <div class="content-width">
            <span>{{ panel.publicTypeName }}</span>
          </div>
        </div>

        <!-- 登録種別 年月日 -->
        <div class="form-group-start m-top-1" v-if="panel.publicDate != null">
          <div class="label-width">
          </div>
          <div class="content-width">
            <span>{{ panel.publicDate }}</span>
          </div>
        </div>

        <!-- カテゴリ -->
        <div class="form-group-start m-top-20px">
          <div class="label-width">
            <span>{{$t("label.help.question.common.category")}}</span>
          </div>
          <div class="content-width">
            <span>{{ panel.categoryName }}</span>
          </div>
        </div>

        <!-- 閲覧区分 -->
        <div class="form-group-start m-top-20px">
          <div class="label-width">
            <span>{{$t("label.help.question.common.browseDifferentiate")}}</span>
          </div>
          <div class="content-width">
            <span>{{ panel.readTypeName }}</span>
          </div>
        </div>

        <!-- 他のビルにも
             同じ質問を作成する -->
        <div class="form-group-start m-top-3">
          <div class="label-width line-height-18 pre">
            <span>{{$t("label.help.question.otherBuilding")}}</span>
          </div>
          <div class="content-width">
            <span
              class="padding-left-43px"
              v-for="(item,index) in panel.buildingOther"
              :key="index">{{item}}</span>
          </div>
        </div>

      </div>

      <!-- タイトル -->
      <div class="faq-title">
        <span>{{ panel.title }}</span>
      </div>

      <!-- 質問/回答 -->
      <div class="faq-confirm-panel">

        <!-- 編集 -->
        <div class="form-group">
          <span class="ft-14">{{ panel.publishUser }}</span>
          <so-smart-btn
            @click="back"
            class="edit-btn">
            <img src="@/assets/icon/sp-icon-edit.svg" class="icon-edit" alt="">
            <span>{{$t("button.common.data.edit")}}</span>
          </so-smart-btn>
        </div>

        <!-- content -->
        <div class="content">

          <!-- Q -->
          <div class="form-group-start">
            <span class="m-right-2 ft-18 font-lato-light">Q</span>
            <div class="m-top-4px">
              <div class="line-height-21">
                <linked-text-area
                  :value="panel.question"
                  class="ft-16 faq-textarea"/>
              </div>
              <div class="line-height-15">
                <span class="building-text">{{ panel.categoryName }} / {{ panel.buildingListStr }}</span>
              </div>
            </div>
          </div>

          <!-- A -->
          <div class="form-group-start m-top-3">
            <span class="m-right-2 ft-18 font-lato-light">A</span>
            <div class="line-height-24">
              <linked-text-area
                :value="panel.answer"
                class="ft-14 faq-textarea"/>
            </div>
          </div>

        </div>

        <!-- 年月日 -->
        <div class="last-updated m-top-1">
          {{ panel.lastUpdated }}
        </div>

        <!-- image -->
        <div class="image-area">
          <smart-office-auth-image
            v-for="(item, index) in panel.imageFileList"
            :key="index"
            :src="item.url"
            @click.native="openImgPop(index, panel.imageFileList)"/>
        </div>

      </div>

      <!-- 登録 -->
      <div class="m-top-60px">
        <narrow-down
          @click="save">
          {{$t("button.common.data.create")}}
        </narrow-down>
      </div>

      <dialog-confirm
        :visible.sync="isDialogConfirm"
        :titleMsg="dialogConfrim.title"
        :contentMsg="dialogConfrim.content"
        :clickFlag="false"
        @on-confirm="doSave"/>

      <dialog-confirm
        :visible.sync="isDialogConfirmComplete"
        :titleMsg="dialogComplete.title"
        :contentMsg="dialogComplete.content"
        :clickFlag="false"
        :cancelFlag="false"
        @on-confirm="faqSearch"/>

      <loading-dialog :dialogVisible="showLoading" />

      <iot-img-pop :visible.sync="openImgPopFlag" :sort="imageSort" :image-list="imageListPop" />

    </div>

  </main-layout>
</template>

<script>
import Menubar from "@/components/leftmenu/Home"
import HeadTitle from "@/components/common/head/head"
import MainLayout from "@/layout/NewDesignLayout"
import SoSmartBtn from "@/components/common/sp-smart-button/index"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import errorCodeMsg from "@/utils/error-code-msg"
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import DialogConfirm from "@/components/common/el-dialog-prompt/confirm"
import LinkedTextArea from "@/components/common/sp-textarea/LinkedTextArea"
import SystemManageApi from "@/api/SystemManageApi"
import SmartOfficeAuthImage from "@/components/common/image/AuthImage"
import iotImgPop from "@/components/common/iotImgPop"
import statusErrorCodeMsg from "@/utils/status-error-msg"

const EDIT_FLAG = "02"
const CREATE_FLAG = "01"
const BUILDING_DEFAULT = "default"

export default {
  name: "CommonQuestionConfirm",
  components: {
    Menubar: Menubar,
    HeadTitle: HeadTitle,
    MainLayout: MainLayout,
    SoSmartBtn: SoSmartBtn,
    narrowDown: narrowDown,
    LoadingDialog: LoadingDialog,
    DialogConfirm: DialogConfirm,
    LinkedTextArea: LinkedTextArea,
    SmartOfficeAuthImage: SmartOfficeAuthImage,
    iotImgPop
  },
  data() {
    return {
      pageFlag: null,
      showLoading: false,
      isDialogConfirm: false,
      isDialogConfirmComplete: false,
      dialogConfrim: {
        title: this.$t("label.help.question.common.contributeTitle"),
        content: this.$t("label.help.question.common.confirmContent"),
      },
      dialogComplete: {
        title: this.$t("label.help.question.common.contributeTitle"),
        content: this.$t("label.help.question.common.faqConfirmDone"),
      },
      panel: {
        publicTypeId: null,
        publicTypeName: null,
        publicDate: null,
        publicDateTime: null,
        categoryId: null,
        categoryName: null,
        readTypeId: null,
        readTypeName: null,
        buildingIdList: [],
        buildingOther: [],
        publishUser: null,
        title: null,
        question: null,
        buildingListStr: null,
        answer: null,
        lastUpdated: null,
        imageList: [],
        imageFileList: [
          {
            id: null,
            url: null
          }
        ],
        deleteImageList: null,
        faqId: null
      },
      publicTypeList: [
        {
          value: "01",
          label: this.$t('label.help.question.immediateOpen')
        },
        {
          value: "02",
          label: this.$t('label.help.question.bookingOpen')
        },
      ],
      imageListPop: [],
      imageSort: null,
      openImgPopFlag: false
    }
  },
  created() {
    this.pageFlag = this.$route.query.pageFlag
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/help/faq/list",
        title: "label.router.faqManageMent",
      },
      {
        path: "",
        title: this.pageFlag == "01" ? "label.router.faqManageMentCreate" : "label.router.faqManageMentEdit",
      },
      {
        path: "",
        title: "label.router.faqManageMentView",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
  },
  mounted() {
    this.getPageInfo()
    this.getUserInfo()
    this.getImage()
  },
  methods: {

    openImgPop (val, list) {
      let imageList = []
      imageList = JSON.parse(JSON.stringify(list))
      this.imageListPop = imageList
      this.imageSort = val
      this.openImgPopFlag = true
    },

    getPageInfo() {
      let pageInfo = this.$getPageInfo("faq", "faqCreateAndEdit", "M-07-05", "content")

      this.panel.publicTypeId = pageInfo.publicType
      this.panel.categoryId = pageInfo.categoryId
      this.panel.categoryName = pageInfo.categoryName
      this.panel.readTypeId = pageInfo.readerRole
      this.panel.readTypeName = pageInfo.readerRoleName
      this.panel.publishUser = ""
      this.panel.title = pageInfo.title
      this.panel.question = pageInfo.question
      this.panel.answer = pageInfo.answer
      this.panel.lastUpdated = this.$dateTimeFormatNoWeek(new Date())

      if (this.pageFlag == EDIT_FLAG) {
        this.panel.faqId = pageInfo.faqId
        this.panel.deleteImageList = pageInfo.deleteImageList
      }

      if (this.$IsNullOrEmpty(pageInfo.publicDateTime) == false) {
        this.panel.publicDate = this.$dateTimeFormat(pageInfo.publicDateTime)
        this.panel.publicDateTime = pageInfo.publicDateTime
      } else {
        this.panel.publicDate = null
        this.panel.publicDateTime = null
      }

      for (let type of this.publicTypeList) {
        if (this.panel.publicTypeId == type.value) {
          this.panel.publicTypeName = type.label
          break
        }
      }

      this.panel.buildingIdList = []
      for (let id of pageInfo.buildingIds) {
        this.panel.buildingIdList.push(id)
      }

      this.panel.buildingOther = []
      this.panel.buildingListStr = ""
      for (let i = 0; i < pageInfo.buildingList.length; i++) {
        if (pageInfo.buildingList[i].type != BUILDING_DEFAULT) {
          this.panel.buildingOther.push(pageInfo.buildingList[i].name)
        }
        this.panel.buildingListStr += pageInfo.buildingList[i].name
        this.panel.buildingListStr += (i == pageInfo.buildingList.length - 1) ? "" : "、"
      }

    },

    getImage() {
      let list = this.$store.state.image.imageList
      this.panel.imageList = []
      this.panel.imageFileList = []
      for (let file of list) {
        if (file.url.substring(0, 4) != "http") {
          this.panel.imageList.push(file)
        }
        this.panel.imageFileList.push(file)
      }
    },

    getUserInfo() {
      let loginInfo = this.$loadLocal("LoginInfo")
      this.panel.publishUser = loginInfo.userInfo.fullname
    },

    save() {
      this.isDialogConfirm = true
    },

    doSave() {
      if (this.pageFlag == CREATE_FLAG) {
        this.createQuestion()
      } else if (this.pageFlag == EDIT_FLAG) {
        this.editQuestion()
      }
    },

    createQuestion() {
      this.showLoading = true

      let imgList = []
      for (let item of this.panel.imageList) {
        let file = this.$dataURLtoFile(item.url, new Date().getTime() + ".png")
        imgList.push(file)
      }

      SystemManageApi.createFaq({
        publicType: this.panel.publicTypeId,
        publicDateTime: this.panel.publicDateTime,
        categoryId: this.panel.categoryId,
        buildingIds: this.panel.buildingIdList,
        readerRole: this.panel.readTypeId,
        question: this.panel.question,
        answer: this.panel.answer,
        title: this.panel.title,
        imageList: imgList
      }).catch((error) => {
        errorCodeMsg(error, this)
        return error
      }).then((resp) => {
        if (resp.data != undefined && resp.data.statusCode == "Success") {
          this.saveSuccess()
        } else {
          statusErrorCodeMsg(resp.data.statusCode, this)
        }
      }).finally(() => {
        this.showLoading = false
      })

    },

    editQuestion() {
      this.showLoading = true

      let imgList = []
      for (let item of this.panel.imageList) {
        let file = this.$dataURLtoFile(item.url, new Date().getTime() + ".png")
        imgList.push(file)
      }

      SystemManageApi.updateFaq({
        publicType: this.panel.publicTypeId,
        publicDateTime: this.panel.publicDateTime,
        faqId: this.panel.faqId,
        categoryId: this.panel.categoryId,
        buildingIds: this.panel.buildingIdList,
        readerRole: this.panel.readTypeId,
        title: this.panel.title,
        question: this.panel.question,
        answer: this.panel.answer,
        imageList: imgList,
        deleteImageList: this.panel.deleteImageList
      }).catch((error) => {
        errorCodeMsg(error, this)
        return error
      }).then((resp) => {
        if (resp.data != undefined && resp.data.statusCode == "Success") {
          this.saveSuccess()
        } else {
          statusErrorCodeMsg(resp.data.statusCode, this)
        }
      }).finally(() => {
        this.showLoading = false
      })

    },

    back() {
      if (this.pageFlag == CREATE_FLAG) {
        this.faqCreate()
      } else if (this.pageFlag == EDIT_FLAG) {
        this.faqEdit()
      }
    },

    saveSuccess() {
      this.isDialogConfirmComplete = true
    },

    faqCreate() {
      this.$router.push({
        name: "help-faq-create",
        params: {
          confirmFlag: true
        }
      })
    },

    faqEdit() {
      this.$router.push({
        name: "help-faq-edit",
        query: {
          faqId: this.panel.faqId
        },
        params: {
          confirmFlag: true
        }
      })
    },

    faqSearch() {
      this.$router.push({
        name: "help-faq-list",
      })
    }

  }
}
</script>

<style scoped lang="scss">
.arrow-back {
  vertical-align: middle;
}
.create-btn::v-deep {
  .my-button {
    height: 32px;
  }
}

.confirm-panel {
  width: 1020px;
  height: 100%;
  border-radius: 8px;
  background-color: #F7F7F2;
  padding: 30px 28px 43px 28px;
  font-size: 16px;
  color: #525250;
}
.form-group-start {
  display: flex;
  align-items: flex-start;
}
.label-width {
  width: 194px;
}
.content-width {
  max-width: 550px;
}
.m-top-20px {
  margin-top: 20px;
}
.line-height-18 {
  line-height: 18px;
}

.faq-title {
  font-size: 24px;
  color: #525250;
  margin-top: 65px;
}

.faq-confirm-panel {
  width: 1020px;
  height: 100%;
  border-radius: 8px;
  background-color: #F7F7F2;
  padding: 40px;
  padding-bottom: 20px;
  color: #525250;
  margin-top: 27px;
}
.icon-edit {
  margin-right: 4px;
}
.edit-btn::v-deep {
  width: 100px;
  height: 32px;
  margin-left: auto;
  background-color: #F7F7F2;
  padding: 0px !important;
  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.content {
  margin-top: 12.5px;
}
.last-updated {
  font-size: 11px;
  color: #5C6570;
  margin-bottom: 20px;
}
.image-area::v-deep {
  display: flex;
  flex-wrap: wrap;
  .auth-image-box {
    width: 300px !important;
    height: 200px !important;
    margin-right: 20px;
    margin-bottom: 20px;
    border-radius: 6px;
  }
  .auth-image-box:nth-child(3n+3) {
    margin-right: 0px;
  }
}
::v-deep .auth-image-box .auth-image {
  object-fit: cover !important;
  border-radius: 6px !important;
}
.m-top-4px {
  margin-top: 4px;
}

.building-text {
  font-size: 11px;
  color: #7D858C;
}
.ft-14 {
  font-size: 14px;
}
.ft-16 {
  font-size: 16px;
}
.ft-18 {
  font-size: 18px;
}
.line-height-15 {
  line-height: 15px;
}
.line-height-21 {
  line-height: 21px;
}
.line-height-24 {
  line-height: 24px;
}

.m-top-60px {
  margin-top: 60px;
}

.faq-textarea {
  padding: 0px !important;
}
.pre {
  white-space: pre;
}

.padding-left-43px {
  padding-left: 43px;
}
.padding-left-43px:nth-child(1) {
  padding-left: 0px;
}
</style>
